import ocRequest from 'oc-request';
import Filter from '../filter/filter';
import Gallery from '../product-gallery/product-gallery';

const selectInit = function Select() {
    const selectHeader = document.querySelectorAll('.select__header');
    const selectItem = document.querySelectorAll('.select__item');
    const selectResetItem = document.querySelectorAll('.select__checkbox-reset');
    let currentDropdown = null;

    function selectReset() {
        const select = this.closest('.select');

        if (select.querySelector('input:checked')) {
            select.querySelectorAll('input:checked').forEach((item) => {
                item.checked = false;
            });
        }

        const currentInput = select.querySelector('.select__input');
        currentInput.setAttribute("value", "")
        this.closest(".filter__item-selectitem").querySelector(".select__current span").innerText = "";
    }
    function selectToggle() {
        this.parentElement.classList.toggle('is-active');
        if (this.parentElement.classList.contains('is-active')) {
            currentDropdown = this.parentNode;
        } else {
            currentDropdown = null;
        }
        let thisSelectElement = this.parentElement
        let els = document.querySelectorAll('.select');
        [].forEach.call(els, function thisSelectElementFunc(el) {
            if(el !== thisSelectElement) {
                el.classList.remove('is-active');
            }
        });
    }
    function selectChoose() {
        const select = this.closest('.select');
        if (!this.hasAttribute('active')) {
            if (select.querySelector('[active]')) {
                select.querySelector('[active]').removeAttribute('active');
            }
            if (select.closest('.failed')) {
                select.closest('.failed').classList.remove('failed');
            }
            const text = this.innerText;
            const value = this.getAttribute('data-value');
            const currentText = select.querySelector('.select__current');

            if(currentText) {
                if (currentText.classList.contains('select__current_placeholder')) {
                    currentText.classList.remove('select__current_placeholder');
                }
                const currentInput = select.querySelector('.select__input');
                if (!select.classList.contains('_shopaholic-sorting')) {
                    this.setAttribute('active', '');
                }
                currentText.innerText = text;
                // currentInput.value = value;
                currentInput.setAttribute("value", value)
                select.classList.add('is-selected');

                // вывов функции сортировка товаров
                if (select.classList.contains(Filter.filterSortingBtn)) {
                    Filter.filterSorting(currentInput.getAttribute('value'));
                }
                // выбор оффера на странице товара
                if (select.classList.contains('product-detail')) {
                    let offer_id = currentInput.getAttribute('value');
                    let offer_curent = null;

                    window.arOfferProductDetail.map(offer => {
                        if(offer.id == offer_id) {
                            offer_curent = offer;
                        }
                    })
                    if(offer_curent) {
                        document.querySelector('._product-detail-price').innerHTML = offer_curent.price;
                        ocRequest.sendData('onSelectOffer', {
                            data: {
                                offer_id: offer_curent.id
                            },
                            update: {
                                'product-preview-text/product-preview-text': '#_product-preview-text',
                                'product-description/product-description': '#_product-description',
                                'product-tags/product-tags': '#_product-tags',
                                'product-gallery/product-gallery': '#_product-gallery'
                            },
                            success: function() {
                                Gallery.init();
                            }
                        })
                    }
                }
            }
            currentDropdown = null;

        }
        select.classList.remove('is-active');
    }
    selectItem.forEach((item) => {
        if (!item.closest('.select').classList.contains('select_init')) {
            item.addEventListener('click', selectChoose);
        }
    });
    selectHeader.forEach((item) => {
        if (!item.closest('.select').classList.contains('select_init')) {
            item.addEventListener('click', selectToggle);
            item.closest('.select').classList.add('select_init');
        }
    });
    selectResetItem.forEach((item) => {
        item.addEventListener('click', selectReset);
    });

    document.addEventListener('click', (e) => {
        if (currentDropdown && e.target !== currentDropdown && !currentDropdown.contains(e.target)) {
            currentDropdown.classList.toggle('is-active');
            currentDropdown = null;
        }
    });
};
selectInit();

[].forEach.call(document.querySelectorAll('.select__header'), function selectHeader(el) {
    el.addEventListener('click', function selectHeaderEl(event) {
        event.currentTarget.querySelector('.select__search').value = '';
        event.currentTarget.querySelector('.select__search').focus();
    })
});
